<template>
  <v-col
    cols="12"
    sm="12"
    class="request-container"
    @click="$emit('show-request')"
  >
    <v-card
      style="border-radius: 0; padding-bottom: 12px"
      v-bind:class="{ urgent: request.is_urgency }"
    >
      <v-row style="margin: 0; margin-bottom: 12px">
        <v-col cols="5" style="padding: 0">
          <div :style="visitTypeStyle">
            {{ request.status }}
          </div>
        </v-col>
        <v-col
          v-if="$store.state.app_display_scheme && request.scheme"
          cols="1"
          style="
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <SchemeIcon :scheme="request.scheme" class="icon-size"/>
        </v-col>
        <v-col cols="3" style="padding: 0; display: flex; align-items: center">
          <div style="margin-left: 12px; font-weight: bold">
            ID: {{ request.id }}
          </div>
        </v-col>
      </v-row>
      <v-row
        align="center"
        style="margin: 0 12px; color: #ff5252"
        v-if="request.is_urgency"
      >
        <b>PEDIDO URGENTE</b>
      </v-row>
      <v-row align="center" style="margin: 0 12px; font-weight: bold">
        {{ request.service }}
      </v-row>
      <v-row align="center" style="margin: 0 12px">
        {{ request.city?.toUpperCase() }} - {{ request.address }}
      </v-row>
    </v-card>
  </v-col>
</template>
<script>
import SchemeIcon from "./SchemeIcon.vue";

export default {
  name: "request-item",
  components: {
    SchemeIcon,
  },
  props: {
    request: Object,
  },
  computed: {
    visitTypeStyle: function () {
      const style = `
        background-color: #1B203F;
        color:white;
        padding: 6px;
        font-size: 14px;
        display: flex;
        justify-content: center;
      `;
      return style;
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .request-container {
    padding: 12px 0;
    padding-top: 0px;
    padding-bottom: 24px;
    background: #eeeeee;
  }
}
.urgent {
  background-color: #fffbcb !important;
}
.icon-size {
  max-width: 25px;
  max-height: 20px;
}
</style>
